<template>
  <span v-if="value && value in SOURCES">
    {{ SOURCES[value] }}
  </span>
</template>

<script setup lang="ts">
const SOURCES = {
  client: 'Client Review',
  linkedin: 'LinkedIn',
  survey: 'Customer Review',
  google: 'Google',
  'trust-pilot': 'Trust Pilot'
}

defineProps({
  value: {
    default: '',
    type: String
  }
})
</script>
